import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['item']
  static values = { selected: String }

  selectedValueChanged(value) {
    this.itemTargets.forEach((el) => {
      el.hidden = el.dataset.conditionalFieldsItemValue !== value
    })
  }

  select(event) {
    this.selectedValue = event.target.value
  }
}
